/** Whether a row's name matches the filter, ignoring case and spacing. */
export function matchesName(name: string, query: string): boolean {
  const needle = query.trim().toLowerCase();
  return needle === '' || name.toLowerCase().includes(needle);
}
